import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface FaqItem {
  question: string;
  answer: string;
}

const faqs: FaqItem[] = [
  {
    question: 'How do I get a FREE website?',
    answer: 'Refer 5 friends who register for their free 1-pager website. Once all 5 have signed up, your website is built and deployed to your own domain — at no cost to you.',
  },
  {
    question: 'What is a 1-pager website?',
    answer: 'A professional single-page website that showcases your business — services, contact info, location, social links, and more. It\'s mobile-optimised, SEO-friendly, and deployed to your own domain (e.g., yourbusiness.co.za).',
  },
  {
    question: 'What domains do you support?',
    answer: 'We support .co.za, .com, .org, .net, and most common TLDs. We can help you register a new domain or use one you already own.',
  },
  {
    question: 'How long does it take to get my website?',
    answer: 'Once all 5 referrals are confirmed, your website is typically built and deployed within 48 hours.',
  },
  {
    question: 'What is the Network Membership?',
    answer: 'The Network Membership (R197/month) gives you full access to the BizBuilder Platform — CRM, automation tools, business dashboards, CJMS customer journey management, and ongoing support to grow your business.',
  },
  {
    question: 'What is a Referral Partner?',
    answer: 'A Referral Partner earns 20% passive commission on every Network Membership they refer. No delivery work required — just refer businesses that join.',
  },
  {
    question: 'What is a Service Delivery Partner?',
    answer: 'A Service Delivery Partner builds and deploys websites for referred businesses and earns 80% commission per project. Training and certification are provided.',
  },
  {
    question: 'Is there a catch?',
    answer: 'No catch. Chrysalinks Group believes in proving value first. Your free website shows what we can do — and when you\'re ready for more, the Network Membership unlocks the full platform.',
  },
  {
    question: 'Can I upgrade later?',
    answer: 'Absolutely. Start with your free website and upgrade to Network Membership or become a partner whenever you\'re ready.',
  },
  {
    question: 'How do I contact support?',
    answer: 'Reach us via WhatsApp at +27 64 638 6983 or email hello@chrysalinks-group.co.za. We typically respond within 2 hours during business hours.',
  },
];

const FaqPage: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-slate-800 mb-4" style={{ fontFamily: "'Fairplay Display', Georgia, serif" }}>
        Frequently Asked Questions
      </h1>
      <p className="text-lg text-slate-600 mb-10">
        Everything you need to know about Chrysalinks Group, the free website offer, and partnership opportunities.
      </p>

      <div className="space-y-3">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="bg-white rounded-xl border border-slate-200 overflow-hidden transition-shadow hover:shadow-md"
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between p-5 text-left font-semibold text-slate-800 hover:bg-slate-50 transition-colors"
            >
              <span>{faq.question}</span>
              <ChevronDown
                size={20}
                className={`flex-shrink-0 ml-4 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              />
            </button>
            {openIndex === index && (
              <div className="px-5 pb-5 text-slate-600 leading-relaxed border-t border-slate-100 pt-4">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-12 p-6 bg-[#4a6580]/5 rounded-2xl border border-[#4a6580]/10 text-center">
        <p className="text-slate-600">
          Still have questions?{' '}
          <a href="https://wa.me/27646386983" className="text-[#4a6580] font-semibold hover:underline">
            Chat with us on WhatsApp
          </a>
        </p>
      </div>
    </div>
  );
};

export default FaqPage;
